/* Whole Woofs — PDP buy-area decorator (Aug 2026 CRO).
 * Read-only enhancement of the existing variant picker + ATC button.
 * Never mutates form inputs, names, values, or event flow.
 * Bails silently if expected DOM/data is missing.
 */
(function () {
  'use strict';

  function parseData() {
    try {
      var el = document.querySelector('.ww-pdp-data');
      if (!el) return null;
      var data = JSON.parse(el.textContent);
      if (!data || !Array.isArray(data.variants)) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function findVariant(data, title) {
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].title === title) return data.variants[i];
    }
    return null;
  }

  function labelTitle(label) {
    var t = label.querySelector('.ww-pk-title');
    if (t) return t.textContent.trim();
    for (var i = 0; i < label.childNodes.length; i++) {
      var n = label.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n.textContent.trim();
    }
    return '';
  }

  function wrapTitle(label) {
    if (label.querySelector('.ww-pk-title')) return;
    for (var i = 0; i < label.childNodes.length; i++) {
      var n = label.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) {
        var s = document.createElement('span');
        s.className = 'ww-pk-title';
        s.textContent = n.textContent.trim();
        label.replaceChild(s, n);
        return;
      }
    }
  }

  function addSpan(label, cls, text) {
    if (label.querySelector('.' + cls.split(' ')[0])) return;
    var s = document.createElement('span');
    s.className = cls;
    s.textContent = text;
    label.appendChild(s);
  }

  function decorateLabels(data) {
    var labels = document.querySelectorAll('.product-info-wrapper variant-radios label.variant-buttons');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (label.getAttribute('data-ww-decorated')) continue;
      var v = findVariant(data, labelTitle(label));
      if (!v) continue;
      wrapTitle(label);
      if (v.kicker) addSpan(label, v.compare ? 'ww-pk-kicker ww-pk-kicker--save' : 'ww-pk-kicker', v.kicker);
      if (v.price) addSpan(label, 'ww-pk-price', v.price);
      if (v.compare) {
        addSpan(label, 'ww-pk-sub ww-pk-sub--strike', v.compare);
      } else if (v.sub) {
        addSpan(label, 'ww-pk-sub', v.sub);
      }
      if (v.badge) addSpan(label, 'ww-pk-badge', v.badge);
      label.setAttribute('data-ww-decorated', '1');
    }
  }

  function selectedVariant(data) {
    var checked = document.querySelector('.product-info-wrapper variant-radios input[type="radio"]:checked');
    if (checked) return findVariant(data, checked.value);
    // single-variant products (bundles) have no picker — use the only variant
    return data.variants.length === 1 ? data.variants[0] : null;
  }

  function updateAtc(data) {
    var btn = document.querySelector('.product-info-wrapper button[name="add"]');
    if (!btn) return;
    var v = selectedVariant(data);
    if (!v || !v.price) return;
    var tag = btn.querySelector('.ww-atc-price');
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'ww-atc-price';
      btn.appendChild(tag);
    }
    var want = ' · ' + v.price;
    if (tag.textContent !== want) tag.textContent = want;
    var display = btn.disabled ? 'none' : '';
    if (tag.style.display !== display) tag.style.display = display;
  }

  function refresh(data) {
    try {
      decorateLabels(data);
      updateAtc(data);
    } catch (e) { /* degrade silently */ }
  }


  function selectDefaultVariant(data) {
    try {
      if (/[?&]variant=/.test(location.search)) return;
      var target = null;
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].badge) { target = data.variants[i]; break; }
      }
      if (!target) return;
      var radios = document.querySelectorAll('.product-info-wrapper variant-radios input[type="radio"]');
      for (var j = 0; j < radios.length; j++) {
        if (radios[j].value === target.title) {
          if (!radios[j].checked && !radios[j].classList.contains('disabled')) radios[j].click();
          return;
        }
      }
    } catch (e) { /* degrade silently */ }
  }

  function init() {
    var data = parseData();
    if (!data) return;

    // Default selection intentionally left to the theme (first variant / URL param).
    refresh(data);

    // variant-radios dispatches 'change' on selection; theme may re-render
    // parts of the buy box async afterwards, so re-run shortly after too.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('variant-radios input[type="radio"]')) {
        refresh(data);
        setTimeout(function () { refresh(data); }, 350);
      }
    });

    // If the theme re-renders the buy box (section fetch), restore decoration.
    var wrapper = document.querySelector('.product-info-wrapper');
    if (wrapper && 'MutationObserver' in window) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () {
          pending = null;
          refresh(data);
        }, 120);
      }).observe(wrapper, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
